import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import driverListingUserPermissionDefinition from "./driver-listing-user-permission";

const useDriverListingUserPermissions = () => {
  return useUserPermissions(driverListingUserPermissionDefinition);
};

export default useDriverListingUserPermissions;
